(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emerald-categories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const links = document.querySelectorAll('[data-er-category-filter]');
    if (!links.length) return;

    links.forEach(function (link) {
      link.addEventListener('click', function () {
        const value = link.getAttribute('data-er-category-filter');
        const btn = document.querySelector('[data-er-filter-btn="' + value + '"]');
        if (btn) btn.click();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["emerald-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-er-collection]');
    if (!root) return;
    const buttons = root.querySelectorAll('[data-er-filter-btn]');
    const cards = root.querySelectorAll('[data-er-filter]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const value = btn.getAttribute('data-er-filter-btn');
        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        cards.forEach(function (card) {
          const match = value === 'all' || card.getAttribute('data-er-filter') === value;
          if (match) {
            card.removeAttribute('hidden');
          } else {
            card.setAttribute('hidden', '');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["emerald-header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-er-header]');
    if (!header) return;
    const toggle = header.querySelector('[data-er-menu-toggle]');
    const menu = header.querySelector('[data-er-mobile-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      if (open) {
        menu.setAttribute('hidden', '');
      } else {
        menu.removeAttribute('hidden');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["emerald-welcome-popup"]) return;
  try {
    
  (function () {
    function initWelcome(root) {
      var dialog = (root || document).querySelector('[data-er-welcome]');
      if (!dialog || dialog.dataset.erBound === 'true') return;
      if (typeof dialog.showModal !== 'function') return;

      dialog.dataset.erBound = 'true';

      var storageKey = dialog.getAttribute('data-storage-key') || 'er-welcome-seen';
      var delay = Number(dialog.getAttribute('data-delay') || 900);
      var inEditor = window.Shopify && Shopify.designMode;
      var cta = dialog.querySelector('[data-er-welcome-cta]');

      function openDialog() {
        if (dialog.open) return;
        dialog.showModal();
      }

      function markSeen() {
        if (inEditor) return;
        try {
          localStorage.setItem(storageKey, '1');
        } catch (error) {
          /* Storage can be blocked; ignore so the dialog still closes. */
        }
      }

      dialog.addEventListener('close', markSeen);

      if (cta) {
        cta.addEventListener('click', function () {
          dialog.close();
        });
      }

      if (!inEditor) {
        try {
          if (localStorage.getItem(storageKey)) return;
        } catch (error) {
          /* If storage is blocked, still show the dialog once this session. */
        }
      }

      window.setTimeout(openDialog, Number.isFinite(delay) ? delay : 900);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initWelcome(document);
      });
    } else {
      initWelcome(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initWelcome(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
